import { lazyRouteComponent } from "@tanstack/react-router";

import type { PageDef } from "@/app/registry";
import { VIEW_AS_PATH, VIEW_ENDED_PATH } from "@/api/viewStore";

/**
 * Admin → Users → "View as this user" (V044): the new tab lands on the
 * hand-over page, which swaps the one-time code for a read-only view of that
 * user's app; "Close view" ends on the second page. Both work signed out.
 */
export const pages: PageDef[] = [];

export const publicPages: PageDef[] = [
  {
    path: VIEW_AS_PATH,
    title: "Opening view",
    component: lazyRouteComponent(() => import("./ViewAsPage"), "ViewAsPage"),
    validateSearch: (s) => (typeof s.code === "string" ? { code: s.code } : {}),
  },
  {
    path: VIEW_ENDED_PATH,
    title: "View ended",
    component: lazyRouteComponent(() => import("./ViewAsPage"), "ViewEndedPage"),
  },
];
